export default {
  id: "guia-decision-matrimonio",
  type: "short_study",
  titleKey: "programs.guia_decision_matrimonio.title",
  descriptionKey: "programs.guia_decision_matrimonio.desc",
  durationDays: 10,
  // Redistribuido desde el bloque "Recursos" de /formacion/ (2026-08-11) — el PDF fuente
  // de este programa, contextual a quien ya lo está viendo.
  resourcePdfs: [
    { titleKey: "resources_marriage_decision_guide", href: "/pdfs/Guia-biblica-sobre-la-decision-del-matrimonio.pdf" },
  ],
  modules: [
    {
      id: "mod-1",
      titleKey: "programs.guia_decision_matrimonio.mod1.title",
      lessons: [
        {
          id: "les-1",
          titleKey: "programs.guia_decision_matrimonio.mod1.les1.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod1.les1.intro",
            },
            {
              type: "verse",
              reference: "1 Juan 4:18",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les1.reference1",
              textKey: "programs.guia_decision_matrimonio.mod1.les1.verse1",
            },
            {
              type: "verse",
              reference: "Filipenses 2:13",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les1.reference2",
              textKey: "programs.guia_decision_matrimonio.mod1.les1.verse2",
            },
          ],
          questions: [
            {
              id: "les1-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod1.les1.q1",
            },
            {
              id: "les1-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod1.les1.q2",
            },
          ],
        },
        {
          id: "les-2",
          titleKey: "programs.guia_decision_matrimonio.mod1.les2.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod1.les2.intro",
            },
            {
              type: "verse",
              reference: "Juan 14:15",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les2.reference1",
              textKey: "programs.guia_decision_matrimonio.mod1.les2.verse1",
            },
            {
              type: "verse",
              reference: "Santiago 1:2-4",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les2.reference2",
              textKey: "programs.guia_decision_matrimonio.mod1.les2.verse2",
            },
          ],
          questions: [
            {
              id: "les2-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod1.les2.q1",
            },
            {
              id: "les2-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod1.les2.q2",
            },
          ],
        },
        {
          id: "les-3",
          titleKey: "programs.guia_decision_matrimonio.mod1.les3.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod1.les3.intro",
            },
            {
              type: "verse",
              reference: "Santiago 1:2-4",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les3.reference1",
              textKey: "programs.guia_decision_matrimonio.mod1.les3.verse1",
            },
            {
              type: "verse",
              reference: "Juan 4:14",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les3.reference2",
              textKey: "programs.guia_decision_matrimonio.mod1.les3.verse2",
            },
          ],
          questions: [
            {
              id: "les3-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod1.les3.q1",
            },
            {
              id: "les3-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod1.les3.q2",
            },
          ],
        },
        {
          id: "les-4",
          titleKey: "programs.guia_decision_matrimonio.mod1.les4.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod1.les4.intro",
            },
            {
              type: "verse",
              reference: "2 Corintios 5:10",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les4.reference1",
              textKey: "programs.guia_decision_matrimonio.mod1.les4.verse1",
            },
            {
              type: "verse",
              reference: "Proverbios 19:20",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les4.reference2",
              textKey: "programs.guia_decision_matrimonio.mod1.les4.verse2",
            },
          ],
          questions: [
            {
              id: "les4-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod1.les4.q1",
            },
            {
              id: "les4-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod1.les4.q2",
            },
          ],
        },
        {
          id: "les-5",
          titleKey: "programs.guia_decision_matrimonio.mod1.les5.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod1.les5.intro",
            },
            {
              type: "verse",
              reference: "Proverbios 22:24",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les5.reference1",
              textKey: "programs.guia_decision_matrimonio.mod1.les5.verse1",
            },
            {
              type: "verse",
              reference: "Gálatas 5:19",
              referenceKey: "programs.guia_decision_matrimonio.mod1.les5.reference2",
              textKey: "programs.guia_decision_matrimonio.mod1.les5.verse2",
            },
          ],
          questions: [
            {
              id: "les5-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod1.les5.q1",
            },
            {
              id: "les5-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod1.les5.q2",
            },
          ],
        },
      ],
    },
    {
      id: "mod-2",
      titleKey: "programs.guia_decision_matrimonio.mod2.title",
      lessons: [
        {
          id: "les-6",
          titleKey: "programs.guia_decision_matrimonio.mod2.les6.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod2.les6.intro",
            },
            {
              type: "verse",
              reference: "Filipenses 2:13",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les6.reference1",
              textKey: "programs.guia_decision_matrimonio.mod2.les6.verse1",
            },
            {
              type: "verse",
              reference: "1 Corintios 13:11",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les6.reference2",
              textKey: "programs.guia_decision_matrimonio.mod2.les6.verse2",
            },
          ],
          questions: [
            {
              id: "les6-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les6.q1",
            },
            {
              id: "les6-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod2.les6.q2",
            },
          ],
        },
        {
          id: "les-7",
          titleKey: "programs.guia_decision_matrimonio.mod2.les7.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod2.les7.intro",
            },
            {
              type: "verse",
              reference: "Éxodo 20:5",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les7.reference1",
              textKey: "programs.guia_decision_matrimonio.mod2.les7.verse1",
            },
            {
              type: "verse",
              reference: "1 Pedro 3:7",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les7.reference2",
              textKey: "programs.guia_decision_matrimonio.mod2.les7.verse2",
            },
          ],
          questions: [
            {
              id: "les7-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les7.q1",
            },
            {
              id: "les7-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod2.les7.q2",
            },
          ],
        },
        {
          id: "les-8",
          titleKey: "programs.guia_decision_matrimonio.mod2.les8.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod2.les8.intro",
            },
            {
              type: "verse",
              reference: "2 Corintios 6:14",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les8.reference1",
              textKey: "programs.guia_decision_matrimonio.mod2.les8.verse1",
            },
            {
              type: "verse",
              reference: "Efesios 2:1-5",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les8.reference2",
              textKey: "programs.guia_decision_matrimonio.mod2.les8.verse2",
            },
          ],
          questions: [
            {
              id: "les8-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les8.q1",
            },
            {
              id: "les8-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod2.les8.q2",
            },
          ],
        },
        {
          id: "les-9",
          titleKey: "programs.guia_decision_matrimonio.mod2.les9.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod2.les9.intro",
            },
            {
              type: "verse",
              reference: "Gálatas 6:2",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les9.reference1",
              textKey: "programs.guia_decision_matrimonio.mod2.les9.verse1",
            },
            {
              type: "verse",
              reference: "Romanos 12:18",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les9.reference2",
              textKey: "programs.guia_decision_matrimonio.mod2.les9.verse2",
            },
          ],
          questions: [
            {
              id: "les9-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les9.q1",
            },
            {
              id: "les9-q2",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod2.les9.q2",
            },
          ],
        },
        {
          id: "les-10",
          titleKey: "programs.guia_decision_matrimonio.mod2.les10.title",
          contentBlocks: [
            {
              type: "text",
              textKey: "programs.guia_decision_matrimonio.mod2.les10.intro",
            },
            {
              type: "verse",
              reference: "1 Juan 4:18",
              referenceKey: "programs.guia_decision_matrimonio.mod2.les10.reference1",
              textKey: "programs.guia_decision_matrimonio.mod2.les10.verse1",
            },
          ],
          questions: [
            {
              id: "les10-q1",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les10.q1",
            },
            {
              id: "les10-q2",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les10.q2",
            },
            {
              id: "les10-q3",
              type: "reflection",
              promptKey: "programs.guia_decision_matrimonio.mod2.les10.q3",
            },
            {
              id: "les10-q4",
              type: "application",
              promptKey: "programs.guia_decision_matrimonio.mod2.les10.q4",
            },
          ],
        },
      ],
    },
  ],
};
